import Notification from "@Features/notification/components/Notification";
import {CountAmenityType} from "@CheckOrder/features/amenities/features/countAmenity/types/CountAmenity.type";

interface NoAmenityForDirectionNotificationProps {
    amenityInOtherDirection: CountAmenityType,
}

function NoAmenityForDirectionNotification(props: NoAmenityForDirectionNotificationProps) {
    const {
        amenityInOtherDirection,
    } = props

    const {
        translations: {
            title,
            notAvailable,
        },
    } = amenityInOtherDirection || {}

    return (
        <>
            <h5 className="amenity-selector__title">
                {title}
            </h5>
            <Notification
                additionalClass="amenity-selector__no-amenity-notification"
                isFullWidth
                notificationType="orange"
                style={{marginBottom: "3rem"}}
            >
                {notAvailable}
            </Notification>
        </>
    )
}

export default NoAmenityForDirectionNotification